var map = {
	"./en.json": 426,
	"./fi.json": 427,
	"./sv.json": 428
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 425;


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/.*\.json$
// module id = 425
// module chunks = 0